import { graphql } from "@/lib/gql/__generated__";

export const PlanStockUpdate_StockManagementPage_Mutation = graphql(`
	mutation PlanStockUpdate_StockManagementPage($input: PlanStockInput!) {
		planStockUpdate(input: $input) {
			userErrors
			planStock {
				id
				hotelID
				headers {
					date
					weekday
				}
				items {
					planID
					name
					isInSale
					isDayTrip
					isSecret
					stocks {
						date
						isAvailable
						remainNum
						soldNum
					}
				}
			}
		}
	}
`);
